import { all, call, fork, takeEvery, put } from 'redux-saga/effects';

// action creators
import { doneIndicator } from 'store/actions/httpActions';

// api
import client from 'sources/api';

// constants
import {
  MEMBER_DELETE_REQUEST,
  MEMBER_DELETE,
} from 'store/constants/memberTypes';

// lib
import httpSaga from 'store/sagas/httpSaga';

// schemas
import { memberSchema } from 'store/schemas/memberSchema';

const WATCH_TYPE = MEMBER_DELETE_REQUEST;
const TYPE = MEMBER_DELETE;

export function* deleteMember(action: any) {
  const { memberId } = action.payload;

  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  yield* httpSaga(TYPE, call(client.delete, `/members/${memberId}`), {
    schema: memberSchema,
    metaId: `delete-${memberId}`,
  });

  yield put(doneIndicator(TYPE));
}

export function* watch() {
  yield takeEvery(WATCH_TYPE, deleteMember);
}

export default function* root() {
  yield all([fork(watch)]);
}
